module.exports = __webpack_public_path__ + "img/icon-calendar-new.dabc2d7.svg";